import { keyframes, styled } from 'styled-components';
import { typography } from '@/styles/helpers';
import { ScDashboardPanelPopup } from '../styled';

const shake = keyframes`
  0%, 100% {
    transform: translateY(var(--art-offset-y, 0px)) rotate(0deg);
  }
  20% {
    transform: translateY(var(--art-offset-y, 0px)) rotate(-8deg);
  }
  40% {
    transform: translateY(var(--art-offset-y, 0px)) rotate(8deg);
  }
  60% {
    transform: translateY(var(--art-offset-y, 0px)) rotate(-6deg);
  }
  80% {
    transform: translateY(var(--art-offset-y, 0px)) rotate(6deg);
  }
`;

export const ScHeadlinePromoButton = styled.button<{
  $issued?: boolean;
  $oversizedArt?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: 0;
  border: none;
  border-radius: 360px;
  background-color: #1c1c1e;
  overflow: hidden;
  cursor: pointer;

  img {
    width: 40px;
    height: 40px;
    object-fit: contain;
    --art-offset-y: ${({ $oversizedArt }) => ($oversizedArt ? '6px' : '0px')};
    transform: translateY(var(--art-offset-y, 0px));
    animation: ${({ $issued }) => ($issued ? shake : 'none')} 1.2s ease-in-out
      infinite;
  }
`;

export const ScHeadlinePromoDesktopPopup = styled(ScDashboardPanelPopup)`
  position: absolute;
  right: 0;
  top: 52px;
  z-index: 100;
  cursor: default;
`;

export const ScHeadlinePromoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  & .info {
    display: flex;
    flex-direction: column;
    gap: 12px;
    ${typography.body1regular}
    letter-spacing: 0.16px;

    .level-info {
      display: flex;
      align-items: center;
      gap: 8px;

      @media (max-width: 340px) {
        gap: 0px;
      }

      .text {
        width: 100%;
        display: flex;
        flex-direction: column;

        b {
          ${typography.body1bold};
        }

        .bold {
          font-weight: 700;
        }
      }

      & > .addons {
        display: flex;
        align-items: center;
        gap: 4px;

        & > img {
          flex-shrink: 0;
        }
      }
    }
  }

  .progress.full {
    .completed {
      border-radius: 24px;
      background: ${({ theme }) => theme.freshLimeGradint} !important;
    }
  }

  .progress .progress-bar-line {
    background-color: ${({ theme }) => theme.whiteColor} !important;

    .completed {
      background: linear-gradient(90deg, #ffad01 20%, #ffd500 80%);
    }


    .progress-value {
      color: ${({ theme }) => theme.blackColor} !important;
    }
  }

  & .addons .circle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    border-radius: 360px;
    background-color: #1c1c1e;

    @media (max-width: 340px) {
      width: 38px;
    }

    & .icon {
      width: 40px;
      height: 40px;
      object-fit: contain;
    }
  }

  .loginBtn {
    min-width: 0;
  }
`;
